module.exports = __webpack_public_path__ + "static/media/lahore-north.555cc357.svg";